import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { Modal } from '@liveauctioneers/hammer-ui-core/modal';
import {
    CloseButton,
    ModalActions,
    ModalContent,
    ModalHeader,
    ModalTitle,
} from '@liveauctioneers/hammer-ui-core/modal/components';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';

import { useAppSelector } from '@/redux/hooks';
import { getBidderEmail } from '@/redux/modules/account/user/user.selectors';

export type TwoStepAuthenticationActivationModalProps = {
    onActivate: () => void;
    onCancel: () => void;
    show: boolean;
};

const TwoStepAuthenticationActivationModal = ({
    onActivate,
    onCancel,
    show,
}: TwoStepAuthenticationActivationModalProps) => {
    const { formatMessage } = useIntl();
    const email = useAppSelector(getBidderEmail);

    return (
        <Modal
            data-testid="TwoStepAuthenticationActivationModal"
            handleClose={onCancel}
            show={show}
            type="composable"
        >
            <CloseButton />
            <ModalHeader>
                <ModalTitle>
                    {formatMessage({
                        id: 'accountSettings.security.twoStepAuthentication.activationModal.header',
                    })}
                </ModalTitle>
            </ModalHeader>
            <ModalContent>
                <BodyPrimary className="text-center">
                    {formatMessage(
                        {
                            id: 'accountSettings.security.twoStepAuthentication.activationModal.description',
                        },
                        { email }
                    )}
                </BodyPrimary>
            </ModalContent>
            <ModalActions>
                <div className="flex flex-col items-center gap-xs">
                    <Button
                        className="w-full"
                        onClick={onActivate}
                    >
                        {formatMessage({
                            id: 'accountSettings.security.twoStepAuthentication.activationModal.activate',
                        })}
                    </Button>
                    <Button
                        className="w-full"
                        onClick={onCancel}
                        variant="outlined"
                    >
                        {formatMessage({ id: 'cancel' })}
                    </Button>
                </div>
            </ModalActions>
        </Modal>
    );
};

export default TwoStepAuthenticationActivationModal;
